import React, { useState, useEffect, useRef } from 'react';
import { makeStyles, withStyles, Card } from '@material-ui/core';
// import { makeStyles, withStyles } from '@material-ui/core/styles';
// import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CustomIconButton from '../CustomIconButton';
import Typography from '@material-ui/core/Typography';
import BasketIcon from '../../icons/BasketIcon';
import FavoritesIcon from '../../icons/FavoritesIcon';
import ArrowSendIcon from '../../icons/ArrowSendIcon';
import ModernSystemsIcon from '../../icons/ModernSystemsIcon';
import AppTagChipArray from './AppTagChipArray';
import AppTagChipArrayTop from './AppTagChipArrayTop';
import AppTagChipArrayBottom from './AppTagChipArrayBottom';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import icons_bn from '../../other/icons_bn.json'
import Chip from '@material-ui/core/Chip';
import ClampLines from "react-clamp-lines";
import AppCardTagList from './AppCardTagList';
import AppCardAlternativeList from './AppCardAlternativeList';
import clsx from 'clsx';
import config from '../../other/config';
import utils from '../../other/utils';
import KloStatus from '../KloSatus';
import FavoriteButton from '../Favorites/FavoriteButton';
import { Favorite } from '@material-ui/icons';
import axios from 'axios';
const { serverAPI } = config;

export default function AppListCard(props) {
	const classes = useStyles();
	let { isProd, readLink, type, basket, notDeleteFromBasketArr, notDeleteFromBasketArrCloud, cart, removeApp, checkAll, setCheckAll, setArrayTag, arrayTag, saveCollection, userCollection } = props
	const height = 0
	const ref = useRef(null)
	const lang = localStorage.getItem('language') || 'Ru';
	let langYE = lang === 'Ru' ? ' тыс.у.е.' : ' K c.u.'
	let langYEM = lang === 'Ru' ? ' тыс.у.е./мес.' : ' K c.u./month'
	let langYER = lang === 'Ru' ? ' тыс.руб.' : ' K rub.'
	let langYEMR = lang === 'Ru' ? ' тыс.руб./мес.' : ' K rub./month'
	// useEffect(() => {
	// 	setHeight(ref.current.clientHeight)
	// }, [bank])
	const [appBasket, _appBasket] = useState(JSON.parse(localStorage.getItem('cartApp')) || [])

	const setAppBasket = (prod) => {
		if (isProd === true) { } else {
			setCheckAll(!checkAll)
		}

		if (appBasket.some((element) => element === prod.ID) === true) {
			_appBasket(appBasket.filter(el_ => el_ !== prod.ID))
			let r = JSON.parse(localStorage.getItem('cartApp')) || []
			localStorage.setItem('cartApp', JSON.stringify(r.filter(el_ => el_ !== prod.ID)))
		} else {
			_appBasket(appBasket.concat(prod.ID));
			let r = JSON.parse(localStorage.getItem('cartApp')) || []
			localStorage.setItem('cartApp', JSON.stringify(r.concat(prod.ID)))
		}
	}

	function PriceCommentELP() {
		return (
			<span>
				{translate.Words[`Price11${lang}`]}
				/
				<br />
				{translate.Words[`Price12${lang}`]}
			</span>
		)
	}

	let tagsName = props.data.tags_q ? props.data.tags_q.split(',').map(el => el.split('#;')[0]).join() : '';
	let inCu = props.userCollection.CatalogCu || props.userCollection.inCu;
	if (inCu === '1' && props.data.Currency === 1) {
		inCu = '0'
	} else if (inCu !== '1' && props.data.Currency === 0) {
		inCu = '1'
	}
	function disablePriority() {
		if (props.usname !== null) {
			if (props.disablePriorityBtn && props.disablePriorityBtn.includes(props.data.codeasvul)) {
				return (true)
			} else if (props.data.RESEARCHMARKETMAILS) {
				return (props.usname === null ? true : props.data.RESEARCHMARKETMAILS.includes(props.usname.email))
			}
		} else {
			return (true)
		}
	}

	function AppCardTopBar() {
		return (
			basket
				?
				<AppTagChipArrayTop //
					lang={lang}
					dataStartSale={props.data.promo}
					variant={1}
					isStandant={props.data.standartpackage}
					isResearchMarket={props.data.researchmarket}
					isCloudApp={props.data.isCloudApp}
					promo={props.data.promo}
					dataEndSale={props.data.dateendsale}
					announcement={props.data.announcement}
					isModernSystems={props.data.isModernSystems}
					isNew={props.data.isNew}
					position='top'
					event={props.data.StockLink ? props.data.StockLink : null}
				/>
				:
				<Grid container direction="row" justify="flex-end" alignItems="center" key={`${props.data.ID}__topChipData`} className={classes.li}>
					<Chip
						style={{ backgroundColor: props.data.color, height: 24, color: '#FFFFFF' }}
						label={props.data && props.data.Progress}
						className={classes.chip}
					/>
				</Grid> // зачем этот компонент?
		)
	}

	function AppCardHeader() {
		return (
			// <Link href={`/${type}/${props.data['url_catalog']}/applist?filt=false&direction=${props.data['businessdirectionid']}`} underlineNone color="inherit" underline="none">
			<CustomCardHeader className={classes.header}
				avatar={
					props.data.isModernSystems === 1
						?
						<Avatar
							aria-label="recipe"
							className={classes.avatar}
							style={{ backgroundColor: '#F0ECF9' }}
							src={icons_bn[`ModernSystems`]}
						></Avatar>
						:
						<Avatar aria-label="recipe" className={classes.avatar}
							style={{ backgroundColor: props.data.color && props.data.color.length > 5 ? `#${props.data.color}` : '#E45670' }}
							src={icons_bn[`${props.data.icon_id_bn}`]}
						></Avatar>
				}

				title={
					(window.location.pathname.slice(1, 5) == "appl" || window.location.pathname.slice(1, 5) == "sear" || window.location.pathname.slice(1, 5) == "cart")
						?
						props.data.isModernSystems === 1
							?
							<Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500' }}>
								{props.data[`ModernSystemBN`]}
							</Typography>
							:
							<a href={`/${props.type}/${props.data['url_catalog']}/applist?filt=false&direction=${props.data['businessdirectionid']}`} className={classes.LinkType01}>
								{props.data[`bn_title`]}
							</a>
						:
						<Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500' }}>
							{props.data[`bn_title`]}
						</Typography>
				}

				subheader={
					(props.data.isModernSystems !== 1 && (window.location.pathname.slice(1, 5) == "appl" || window.location.pathname.slice(1, 5) == "sear" || window.location.pathname.slice(1, 5) == "cart"))
						?
						<a href={`/${props.type}/${props.data['url_catalog']}/applist?filt=false&direction=&section=${props.data['sectionid']}`} className={classes.LinkType02} style={{ marginTop: 4 }}>
							<ClampLines
								id={'subheader_' + props.data[`ID`]}
								text={props.data[`sn_title`] !== null ? props.data[`sn_title`] : ''}
								lines={2}
								buttons={false}
								ellipsis="..."
								className={classes.LinkType02}
								innerElement="p"
							/>
						</a >
						:
						props.data.isModernSystems === 1
							?
							<Typography className={classes.subheader} style={{ marginTop: 4 }}>
								{props.data[`ModernSystemProduct`]}
							</Typography>
							:
							<ClampLines
								id={'subheader_' + props.data[`ID`]}
								text={props.data[`sn_title`] !== null ? props.data[`sn_title`] : ''}
								lines={2}
								buttons={false}
								ellipsis="..."
								className={classes.ClampLinesSubheader}
								style={{ marginTop: 4 }}
								innerElement="p"
							/>
				}
			/>
			// </Link>
		)
	}

	/* ЦЕНА ПО АКЦИИ >>>>> */
	function ActionPriceOne() {
		if (+props.data.paymentonestock) {
			if (+props.data.paymentonestock < +props.data.paymentone) {
				return (
					<Grid item style={{ display: 'inline-flex' }}>
						<CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования – см. страницу с описанием Приложения' : "Special license terms – see. Application description page"}>
							<Typography className={classes.pricePrimary}>
								{
									props.data.paymentonestock
								}
							</Typography>
						</CustomTooltip>

						<CustomTooltip title={<span>
							{translate.Words[`CurrentRate_${lang}`]}
							{/* <br />{translate.Words[`NextRate_${lang}`]} */}
						</span>}>
							<Typography className={classes.pricePrimary} style={{ paddingLeft: 4 }}>
								{inCu === '1' ? langYE : langYER}
							</Typography>
						</CustomTooltip>
					</Grid>
				)
			}
		}
	}

	function ActionPriceMonthly() {
		if (+props.data.paymentmonthlystock) {
			if (+props.data.paymentmonthlystock < +props.data.paymentmonthly) {
				return (
					<Grid item style={{ display: 'inline-flex' }}>
						<CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования – см. страницу с описанием Приложения' : "Special license terms – see. Application description page"}>
							<Typography className={classes.pricePrimary}>
								{
									props.data.paymentmonthlystock
								}
							</Typography>
						</CustomTooltip>

						<CustomTooltip title={<span>
							{translate.Words[`CurrentRate_${lang}`]}
							{/* <br />{translate.Words[`NextRate_${lang}`]} */}
						</span>}>
							<Typography className={classes.pricePrimary} style={{ paddingLeft: 4 }}>
								{inCu === '1' ? langYEM : langYEMR}
							</Typography>
						</CustomTooltip>
					</Grid>
				)
			}
		}
	}
	/* <<<<< ЦЕНА ПО АКЦИИ */

	function AppCardContent() {
		let h = (Math.floor(props.data.title.length / 25) * 18) + 18
		let h2 = (Math.floor(props.data.briefdescription.length / 25) * 18)
		// console.log("readLink",readLink)
		return (
			<CardContent className={classes.content} style={{ marginTop: 0, padding: 0 }}>
				{readLink === true
					?
					<Grid container style={{ height: 147, overflow: 'hidden' }}>
						<Grid container direction="column" justify="flex-start" alignItems="flex-start">
							<Grid item ref={ref} style={{ maxWidth: '100%' }}>
								<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
									{props.data.title}
								</Typography>
							</Grid>

							<React.Fragment>
								<div>{props.data.Progress2} </div>
								{
									Math.sign(147 - (h + h2)) === -1
										?
										<CustomTooltip title={props.data.briefdescription}>
											<Typography variant="body2" color="textSecondary" component="div" className={classes.contentSubbody}>
												<ClampLines
													text={props.data.briefdescription}
													lines={Math.floor((147 - h) / 16)}
													buttons={false}
													ellipsis=" ..."
												/>
												{/* {props.data.briefdescription} */}
											</Typography>
										</CustomTooltip>
										:
										<Typography variant="body2" color="textSecondary" component="div" className={classes.contentSubbody}>
											<ClampLines
												text={props.data.briefdescription}
												lines={Math.floor((147 - h) / 16)}
												buttons={false}
												ellipsis=" ..."
											/>
										</Typography>
								}
							</React.Fragment>
						</Grid>
					</Grid>
					:
					props.data.isModernSystems === 1
						?
						<Grid container style={{ height: 147, overflow: 'hidden' }}>
							<Grid container direction="column" justify="flex-start" alignItems="flex-start">
								<Grid item ref={ref} style={{ maxWidth: '100%' }}>
									<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
										{props.data.title}
									</Typography>
								</Grid>

								<Typography variant="body2" color="textSecondary" component="div" style={{ maxHeight: 122 - height, maxWidth: '100%' }} className={classes.contentSubbody}>
									<ClampLines
										text={props.data.briefdescription}
										lines={Math.floor((147 - h) / 16)}
										buttons={false}
										ellipsis="..."
									/>
									{/* {props.data.briefdescription} */}
								</Typography>
							</Grid>
						</Grid>
						:
						<a href={`/${type}/card/${props.data['codeasvul']}`} style={{ textDecoration: 'none' }} rel="noopener noreferrer" target="_blank">
							<Grid container style={{ height: 147, overflow: 'hidden' }}>
								<Grid container direction="column" justify="flex-start" alignItems="flex-start">
									<Grid item ref={ref} style={{ maxWidth: '100%' }}>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
											{props.data.title}
										</Typography>
									</Grid>

									<Typography variant="body2" color="textSecondary" component="div" style={{ maxHeight: 122 - height, maxWidth: '100%' }} className={classes.contentSubbody}>
										<ClampLines
											text={props.data.briefdescription}
											lines={Math.floor((147 - h) / 16)}
											buttons={false}
											ellipsis="..."
										/>
										{/* {props.data.briefdescription} */}
									</Typography>
								</Grid>
							</Grid>
						</a>
				}
			</CardContent >
		)
	}

	const renderAppCurrency = (type, condition) => (
		inCu === '1'
			?
			<CustomTooltip title={<span>
				{translate.Words[`CurrentRate_${lang}`]}
				{/* <br />{translate.Words[`NextRate_${lang}`]} */}
			</span>}>
				<Typography
					className={clsx(classes.pricePrimary, {
						[classes.priceSecondary]: condition
					})}
					style={{ paddingLeft: 4 }}
				>
					{utils.getPriceItem(inCu, lang, type)}
				</Typography>
			</CustomTooltip>
			:
			<Typography
				className={clsx(classes.pricePrimary, {
					[classes.priceSecondary]: condition
				})}
				style={{ paddingLeft: 4 }}
			>
				{utils.getPriceItem(inCu, lang, type)}
			</Typography>
	)

	const renderPrice = () => {
		if (props.data.isHidePrice === 1) {
			return (
				<Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0, justifyContent: 'space-between' }}>
					<Grid item style={{ display: 'grid', height: 36, minWidth: '30%' }}> {lang === 'Ru' ? 'По запросу' : 'On request'} </Grid>
				</Grid>
			)
		} else {
			return (
				<Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0, justifyContent: 'space-between' }}>
					<Grid item={inCu === '1'} style={{ display: 'grid', height: inCu !== '1' || +props.data.paymentonestock < 1000000 ? undefined : 36, minWidth: '30%' }}>

						{ActionPriceOne()}

						<Grid item style={{ display: 'inline-flex' }}>
							<CustomTooltip title={PriceCommentELP()}>
								<Typography
									className={clsx(classes.pricePrimary, {
										[classes.priceSecondary]: +props.data.paymentonestock > 0 && +props.data.paymentonestock < +props.data.paymentone
									})}
								>
									{
										utils.getCurrentPrice(props.data.paymentone, lang)
									}
								</Typography>
							</CustomTooltip>

							{
								typeof props.data.paymentone === 'number' && props.data.paymentone > 0
									?
									renderAppCurrency('elp', +props.data.paymentonestock > 0 && +props.data.paymentonestock < +props.data.paymentone)
									:
									null
							}

							<HtmlTooltip
								interactive
								title={
									props.data.paymentcommentone !== '*' && props.data.paymentcommentone !== '**'
										?
										<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcommentone }} style={{ fontSize: '14px !important' }}></Grid>
										:
										<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}></Grid>
								}
							>
								{
									props.data.paymentcommentone?.length > 4
										?
										<Typography className={classes.pricePrimary}>*</Typography>
										:
										<Typography className={classes.pricePrimary}>{props.data.paymentcommentone}</Typography>
								}
							</HtmlTooltip>
						</Grid>
					</Grid>

					{/* ========================================================================================================================== */}
					<Grid item={props.inCu === '1'} style={{ display: 'grid', height: inCu !== '1' || +props.data.paymentmonthly < 1000000 ? undefined : 36, minWidth: '30%' }}>

						{ActionPriceMonthly()}

						<Grid item style={{ display: 'inline-flex' }}>
							{/* { */}
							<CustomTooltip title={lang === 'Ru' ? 'Ежемесячный лицензионный платеж / Периодическая лицензия' :
								"Monthly license payment / Periodic license"}>
								<Typography
									className={clsx(classes.pricePrimary, {
										[classes.priceSecondary]: +props.data.paymentonestock > 0 && +props.data.paymentmonthlystock < +props.data.paymentmonthly
									})}
								>
									{
										utils.getCurrentPrice(props.data.paymentmonthly, lang)
									}

								</Typography>
							</CustomTooltip>

							{
								typeof props.data.paymentmonthly === 'number' && props.data.paymentmonthly > 0
									?
									renderAppCurrency('lp', +props.data.paymentonestock > 0 && +props.data.paymentmonthlystock < +props.data.paymentmonthly)
									:
									null

							}

							<HtmlTooltip
								interactive
								title={
									props.data.paymentcommentmonthly?.length > 5
										?
										<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcommentmonthly }} style={{ fontSize: '14px !important' }}>
										</Grid>
										:
										props.data.paymentcommentmonthly !== '*'
											?
											''
											:
											<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
											</Grid>
								}
							>
								<Typography component='span' className={classes.pricePrimary} style={{ cursor: 'default', maxWidth: 5 }}>{props.data.paymentcommentmonthly?.length > 5 ? '*' : props.data.paymentcommentmonthly}</Typography>
							</HtmlTooltip>
						</Grid>
					</Grid>
				</Grid>
			)
		}
	}

	function AppCardPriceContainer() {
		// if (props.ownerApp && props.data) {
		// 	fetchData();
		// }

		return (
			<Grid item container style={{ marginTop: 22 }}>
				<Grid container direction="row" justify="flex-start" alignItems="center" className={classes.container} spacing={3} style={{ minHeight: 55, alignItems: "start", marginTop: 0 }}>
					{props.data.researchmarket !== "" ? "" :
						<AppTagChipArray position='middle'
							// handleClick={props.addTagtoArray}
							key1={props.data.codeasvul}
							key2={props.data.version}
							key3={props.data.datestartsale}
						/>}
				</Grid>

				<React.Fragment>
					<Grid container direction="row" alignItems="center" className={classes.container} style={{ margin: '19px 0 0 0' }}>
						<Grid item style={{ padding: 0, marginBottom: 4 }}>
							{/* <CustomTooltip title={props.data.paymentcomment !== '*' ? '' : lang === 'Ru' ? 'Особые условия лицензирования' :
									"Special licensing conditions"}> */}

							<HtmlTooltip
								interactive
								title={
									props.data?.paymentcomment?.length > 5
										?
										<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcomment }} style={{ fontSize: '14px !important' }}></Grid>
										:
										props.data.paymentcomment !== '*'
											?
											''
											:
											<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}></Grid>
								}
							>
								{
									props.data.researchmarket /* Предполагаемая цена / Цена на карточках */
										?
										<Typography className={classes.subheader}>
											{translate.Words[`PlannedPrice${lang}`]} {props.data.paymentcomment?.length > 5 ? '*' : props.data.paymentcomment}
										</Typography>
										:
										<Typography className={classes.subheader}>
											{translate.Words[`Price${lang}`]}{props.data.paymentcomment?.length > 5 ? '*' : props.data.paymentcomment}
										</Typography>
								}
							</HtmlTooltip>
						</Grid>

						{/* ========================================================================================================================== */}
						{/* <Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0, justifyContent: 'space-between' }}>
									<Grid item style={{ display: 'inline-flex' }}>
										{ActionPriceOne()}
									</Grid>

									<Grid item style={{ display: 'inline-flex' }}>
										{ActionPriceMonthly()}
									</Grid>
								</Grid> */}

						{renderPrice()}
					</Grid>
				</React.Fragment>

				{/* <Grid item style={{ marginLeft: -8, marginTop: 38, minHeight: 24, width: '100%' }} ></Grid> */}
				<Grid item container direction='row' style={{ marginLeft: -8, marginTop: 30, marginBottom: 8, minHeight: 24, maxHeight: 24, overflow: 'hidden', width: "100%" }} >
					{/* {cart
						?
						<SimpleAppTagChipArrayBottom
							tags={(tagsName.length > 29 ? tagsName.slice(0, tagsName.slice(0, 29).lastIndexOf(',')) : tagsName) + (tagsName.length > 29 ? ', ...' : '')}
							tt={tagsName.slice(tagsName.slice(0, 29).lastIndexOf(','))} />
						: */}
					<Grid item xs={6}>
						{
							utils.hasProperty(props.data.tags_q)
								?
								<AppCardTagList
									tagsQ={props.data.tags_q}
									setArrayTag={setArrayTag}
									arrayTag={arrayTag}
									codeasvul={props.data.codeasvul}
								/>
								:
								null
						}
					</Grid>

					<Grid item xs={6}>
						{
							props.alternatives?.filter(obj => obj.DependID === props.data.ID)
								?
								<AppCardAlternativeList
									analogs={[...new Set(props.alternatives?.filter(obj => obj.DependID === props.data.ID).map(alt => alt.Alternatives).join().split(','))].join()}
									codeasvul={props.data.codeasvul}
									inCu={inCu}
								/>
								:
								null
						}
					</Grid>
					{/* <AppTagChipArrayBottom
						setArrayTag={setArrayTag}
						arrayTag={arrayTag}
						tags_q={props.data.tags_q}
						position='bottom'
						tags={(tagsName.length > 28 ? tagsName.slice(0, tagsName.slice(0, 28).lastIndexOf(',')) : tagsName) + (tagsName.length > 28 ? ', ...' : '')}
						tt={tagsName.slice(tagsName.slice(0, 28).lastIndexOf(',') + 1)}
						cart={cart}
					/> */}
					{/* } */}
				</Grid>
			</Grid>
		)
	}



	const renderFavoritesIcon = (row, isCart, appFavorite, appsInProducts) => {
		let appInFavorite = appFavorite && appFavorite.includes(row.ID);
		let title = appInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
		let fill = appInFavorite ? '#FFFFFF' : '#BCBBD0';
		let onClick = /*isBasket ?*/ () => { saveCollection(row.ID, 'app', 'favorite'); if (isCart && !!props.updateArr) { props.updateArr('favorite', row, 'app'); } };
		let backgroundColor = appInFavorite ? '#EB505E' : undefined;
		if (appsInProducts.includes(row.ID)) {
			fill = '#BCBBD0';
			backgroundColor = undefined;
			title = translate.Words[`AppIsPartOfProducts_${lang}`];
			onClick = () => { }
		}

		return (
			row.dateendsale.length > 2 || row.researchmarket.length > 2 || row.isModernSystems === 1
				?
				null
				:
				<FavoriteButton fill={fill} title={title} onClick={onClick} backgroundColor={backgroundColor} />
		)
	}

	const renderBasketIcons = (row, isBasket, appBasket, appsInProducts) => {
		if (row.researchmarket == "Изучается спрос" || row.researchmarket == "Demand under research") {
			return (
				<HtmlTooltip
					interactive
					title={
						props.usname === null
							?
							lang === 'Ru'
								?
								<Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы повысить приоритет </Grid>
								:
								<Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to raise priority </Grid>
							:
							row.RESEARCHMARKETMAILS && row.RESEARCHMARKETMAILS.includes(props.usname.email)
								?
								<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`YourVoteHasBeenRegistered${lang}`]} </Grid>
								:
								<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`ClickToIncreasePriority${lang}`]} </Grid>
					}
				>
					<Grid item>
						<CustomIconButton
							aria-label="share"
							className={classes.icon}
							disabled={disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS)}
							func={() => props.upPriority(row.RESEARCHMARKETMAILS, row.codeasvul)}
							bgcolor={'#F6F6FB'}
							hbgcolor={'#5D75F8'}
							shadow={'none'}
							hshadow={'0px 6px 24px rgba(128, 148, 255, 0.4)'}
							icon={props.usname === null ? 1 : disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS) ? 2 : 1}
							discolor={disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS) ? '#EEEEF5' : null}
						/>
					</Grid>
				</HtmlTooltip>
			)
		} else if (row.isModernSystems === 1) {
			return (
				<IconButton onClick={() => window.open(`https://${row.ModernSystemLink}`)} color={'primary'} aria-label="share" className={classes.icon} style={{ backgroundColor: appBasket && appBasket.includes(row.ID) ? '#7D62BA' : '' }}>
					<ModernSystemsIcon fill={appBasket && appBasket.includes(row.ID) ? '#FFFFFF' : '#BCBBD0'} />
				</IconButton>
			)
		} else {
			//console.log("appBasket",appBasket,notDeleteFromBasketArr, )
			let appInBasket = appBasket && appBasket.includes(row.ID);
			let title = appInBasket ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`];

			//let onClick = isBasket ? () => {removeApp(row)} : () => {setAppBasket(row)} ;
			let backgroundColor = appInBasket ? '#EB505E' : undefined;
			let fill = appInBasket ? '#FFFFFF' : '#BCBBD0'
			let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'app', 'cart'); if (!!props.updateArr) { props.updateArr('cart', row, 'app'); } };

			if (appsInProducts.includes(row.ID)) {
				fill = '#BCBBD0';
				backgroundColor = undefined;
				title = translate.Words[`AppIsPartOfProducts_${lang}`];
				onClick = () => { }
			}
			return (
				row.dateendsale.length > 2 || row.researchmarket.length > 2
					?
					null
					:
					<CustomTooltip placement="bottom" title={title}>
						<IconButton color={'primary'} aria-label="share" onClick={onClick} className={classes.icon} style={{ backgroundColor }}>
							<BasketIcon fill={fill} />
						</IconButton>
					</CustomTooltip>
			)
		}
	}


	function AppCardActions() {
		return (
			<CardActions disableSpacing className={classes.actions}>
				<Grid item >
					{renderFavoritesIcon(props.data, cart, userCollection.appFavorite, userCollection.appFavoriteInProduct)}
					{renderBasketIcons(props.data, cart, userCollection.appBasket, userCollection.appCartInProduct)}
				</Grid>
			</CardActions>
		)
	}

	return (
		<Grid codeasvul={props.data.codeasvul} >
			{
				props.data.isModernSystems === 1
					?
					<a href={`https://${props.data.ModernSystemLink}`} style={{ textDecoration: 'none', maxWidth: '100%' }} rel="noopener noreferrer" target="_blank">
						<Card className={props.wide === false ? classes.rootNarrow : classes.rootWide}>
							<Grid container id="ip" direction="column"
								justify="space-between"
								alignItems="center"
								style={{ height: "100%" }}
							>
								<Grid item container>
									<Grid item container style={{ height: 34 }}>
										{AppCardTopBar()}
									</Grid>

									<Grid item style={{ width: '100%', marginTop: 4 }}>
										{
											props.data.isModernSystems === 1
												?
												<Grid item style={{ height: 21 }}></Grid>
												:
												<Typography component='span' style={{ fontSize: '14px' }}>{props.data.Title_catalog}</Typography>
										}
									</Grid>

									{AppCardHeader()}
								</Grid>

								<Grid item container
								// style={{ height: 'calc(100% - 132px)' }}
								>
									{/* {AppCardHeader()} */}

									{AppCardContent()}
								</Grid>

								<Grid item container>
									{AppCardPriceContainer()}

									<Grid item container direction="row" justify="space-between" alignItems="center" style={{ marginTop: 7, height: 48 }}>
										{
											props.data.isModernSystems === 1
												?
												<React.Fragment>
													<Grid item style={{ maxWidth: '80%' }}>
														<Typography style={{ color: '#7D62BA', fontSize: '13px', lineHeight: '16px' }}>С сайта </Typography>
														<Typography style={{ color: '#7D62BA', fontSize: '13px', lineHeight: '16px' }}>“Современные Системы”</Typography>
													</Grid>
													<Grid item></Grid>
												</React.Fragment>

												:
												<Grid item></Grid>
										}

										{AppCardActions()}
										{/* <SnackbarAppBasket func={AppCardActions()} /> */}
										{/* <Button onClick={handleClick}>BuToN</Button> */}

										{/* <SnackbarAddBasket /> */}
									</Grid>
								</Grid>
							</Grid>
						</Card>
					</a>
					:
					<Card className={props.wide === false ? classes.rootNarrow : classes.rootWide}>
						<Grid container id="ip" direction="column"
							justify="space-between"
							alignItems="center"
							style={{ height: "100%" }}
						>
							<Grid item container>
								<Grid item container style={{ height: 34 }}>
									{AppCardTopBar()}
								</Grid>

								<Grid item style={{ width: '100%', marginTop: 4 }}>
									{
										props.data.isModernSystems === 1
											?
											<Grid item style={{ height: 21 }}></Grid>
											:
											<Typography component='span' style={{ fontSize: '14px' }}>{props.data.Title_catalog}</Typography>
									}
								</Grid>

								{AppCardHeader()}
							</Grid>

							<Grid item container
							// style={{ height: 'calc(100% - 132px)' }}
							>
								{/* {AppCardHeader()} */}

								{AppCardContent()}
							</Grid>

							<Grid item container>
								{AppCardPriceContainer()}

								<Grid item container direction="row" justify="space-between" alignItems="center" style={{ marginTop: 7, height: 48 }}>

									<Grid item style={{ maxWidth: '80%' }}>
										<KloStatus kloUser={props.kloUser} kloStatus={props.kloStatuses[props.data.codeasvul]} codeasvul={props.data.codeasvul} loadingKloStatuses={props.loadingKloStatuses} />

										{/* <Typography style={{ color: '#7D62BA', fontSize: '13px', lineHeight: '16px' }}>“Современные Системы”</Typography> */}
									</Grid>


									{AppCardActions()}
									{/* <SnackbarAppBasket func={AppCardActions()} /> */}
									{/* <Button onClick={handleClick}>BuToN</Button> */}

									{/* <SnackbarAddBasket /> */}
								</Grid>
							</Grid>
						</Grid>
					</Card>
			}
		</Grid>
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.87)',
		color: 'rgba(255, 255, 255, 0.87)',
		maxWidth: 500,
		fontSize: theme.typography.pxToRem(12),
		// border: '1px solid #dadde9',
		borderRadius: '8px',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 400,
		padding: 12,
		// paddingBottom: 0,
		opacity: 0.5,

		'& a': {
			color: 'rgba(255, 255, 255, 0.87)',
		}
	},
}))(Tooltip);

const CustomCardHeader = withStyles((theme) => ({
	root: {
		alignItems: 'flex-start'
	},

	avatar: {
		marginRight: 8
	},

	title: {
		lineHeight: "14px",
	},

	subheader: {
		lineHeight: "14px",
		marginTop: 4,
	}
}))(CardHeader);

const useStyles = makeStyles((theme) => ({
	rootNarrow: {
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		paddingTop: 10,
		paddingBottom: 16,
		padding: theme.spacing(3),
		minHeight: 581,
		height: 581,
		maxHeight: 581,
		minWidth: 312,
		width: 312,
		maxWidth: 312,
		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	rootWide: {
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		paddingTop: 10,
		paddingBottom: 16,
		padding: theme.spacing(3),
		minHeight: 246,
		height: 246,
		maxHeight: 246,
		minWidth: 312,
		width: '100%',
		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	avatar: {
		// backgroundColor: props.iconColor,
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		// height: 297,
		// overflow: 'hidden',
		padding: 0,
		marginTop: 15,
		maxWidth: '264px !important',
		width: 264
	},

	contentBody: {
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '18px',
		color: '#000'
	},

	contentSubbody: {
		marginTop: theme.spacing(1),
		fontSize: '13px',
		fontWeight: '400',
		lineHeight: '16px',
		color: '#8987A2'
	},

	header: {
		padding: 0,
		marginTop: 13,

		title: {
			fontSize: 22
		}
	},

	subheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2'
	},

	actions: {
		padding: '0',
		paddingTop: '7',
		// position: 'absolute',
		// bottom: 16,
		// right: 24
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#8987A2',
		textDecoration: 'line-through'
	},

	DN: {
		display: 'none'
	},

	snackbarPostroot: {
		padding: 24,
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
	},

	postroot: {
		padding: 24,
		alignItems: 'center',
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		boxSizing: 'borderBox',
	},

	LinkType01: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: '500',
		color: "#000000",
		textDecoration: "none",

		'&:hover': {
			textDecoration: 'none',
			borderBottom: '1px solid #000000',
		}
	},

	LinkType02: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: "none",

		"& > p": {
			fontSize: '12px',
			lineHeight: '14px',
			fontWeight: 400,
			color: '#8987A2',
			textDecoration: "none",
			margin: 0,

			'&:hover': {
				textDecoration: 'underline',
			}
		}
	},

	ClampLinesSubheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: "none",

		"& > p": {
			fontSize: '12px',
			lineHeight: '14px',
			fontWeight: 400,
			color: '#8987A2',
			textDecoration: "none",
			margin: 0,
		}
	},
}));

// export default React.memo(AppListCard) ;